export default {
  RECAPTCHA_ERROR: 'recaptcha_error',
  RECAPTCHA_REQUIRED: 'recaptcha_required',
};
